module.exports = __webpack_public_path__ + "static/img/icon_crje.3c295f4e.png";